import React from "react";
import ContactSec from "../sections/contactus/ContactSec";

import AOS from "aos"; // Import AOS library
import Banner from "../components/Banner";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";

const ContactUs = () => {
  React.useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
      />
      <Banner
        title={t("contact")}
        desc={t("banner_desc_career")}
      ></Banner>
      <ContactSec></ContactSec>
    </>
  );
};

export default ContactUs;
